import React, { Component } from 'react'
import styled from 'styled-components'
import Checkmark from 'cogsworth/components/Checkmark/Checkmark'
import PaymentDetails from 'cogsworth/components/PaymentDetails/PaymentDetails'
import { injectValuesIntoTemplate } from '../../utils/templates'
import { translate } from "react-i18next"
import './BookingConfirmation.css'

class BookingConfirmation extends Component {

  getThemedConfirmation(){
    return styled.div`
      em { color: ${props => props.theme.main}; }
      .btn-primary {
        background: ${props => props.theme.main};
        border-color: ${props => props.theme.main};
        &:hover {
          background: ${props => props.theme.hover};
          border-color: ${props => props.theme.hover};
        }
      }
      .checkmark { box-shadow: inset 0px 0px 0px ${props => props.theme.hover}; }
      .checkmark__circle { stroke: ${props => props.theme.hover};  }
      @keyframes fill {
        100% {
          box-shadow: inset 0px 0px 0px 30px ${props => props.theme.hover};
        }
      }
    `
  }

  renderTrackingPixel(){
    const { business } = this.props

    if(business.availableFeatures.trackingPixel && business.trackingPixelUrl) {
      return <img src={business.trackingPixelUrl} alt="Tracking Pixel" height="1" width="1" />
    }

    return null
  }

  getThankYouHtml() {
    const { savedAppointment, business } = this.props
    const service = business.services.find(s => s.id === savedAppointment.service.id)

    // Show confirmation message for bookings that require approval
    if (!savedAppointment.approved) {
      return `
        <div>
          <span>Your appointment has been requested.</span>
          <p style="margin: 0;">You will receive an email when it is approved.</p>
        </div>
      `
    }

    const customerName = savedAppointment.answers && savedAppointment.answers.length > 0 ? savedAppointment.answers.find(f => f.id === 'name').answer : savedAppointment.customer.name

    return injectValuesIntoTemplate(business.bookingTemplatesHtml["thankyou-screen"], {
      service,
      booking: {
        ...savedAppointment,
        customerName
      },
      dateFormat: business.dateFormat
    })
  }

  render() {
    const { savedAppointment, cancelledAppointment, business, t } = this.props
    const ThemedBookingConfirmation = this.getThemedConfirmation()

    if( savedAppointment ) {
      return (
        <ThemedBookingConfirmation className="booking-confirmation">
          <div className="inner">
            <Checkmark color={business.color} />
            <div dangerouslySetInnerHTML={{ __html: this.getThankYouHtml() }}></div>
            <PaymentDetails payment={this.props.payment} />
            {/* TODO: Stripe details */}
            { this.renderTrackingPixel() }
          </div>
        </ThemedBookingConfirmation>
      );
    }

    if( cancelledAppointment ) {
      return (
        <ThemedBookingConfirmation className="booking-confirmation">
          <div className="inner">
            <Checkmark color={business.color} />
            <h1>{ t("thank-you-customer", { name: cancelledAppointment.customer.name }) }</h1>
            <em>{ t("appointment-cancelled") }</em>
            <p>{ t("confirmation-sent") }</p>
          </div>
        </ThemedBookingConfirmation>
      );
    }
  }
}

export default translate("translations")(BookingConfirmation)
